import { find, propEq, defaultTo, compose, sortBy, path, map, prop, flatten, reduce, or } from 'ramda'

const transformToOutOfStocks = compose(map(prop('outOfStock')), prop('availabilityTickets'))

export const findByType = (type) => compose(defaultTo({}), find(propEq('type', type)))
export const timeSort = sortBy(path(['sail', 'departure', 'time']))
export const checkOutOfStock = compose(reduce(or, false), flatten, map(transformToOutOfStocks))
